import { useLazyQuery } from '@apollo/client'
import { useEffect, useState } from 'react'

import { useAbility } from 'providers/casl'
import { fromDTO, sortToDTO } from './api/mapper'
import { GET_AD_UNIT_BIDDERS } from './api/query'
import { AdUnitBidderSliceDTO } from './api/types'
import { AdUnitBidderSlice, Props, UseGetAdUnitBidders } from './types'

export const useGetAdUnitBidders = ({
  domainBidder,
  filters,
  first,
  last,
  sort,
}: Props): UseGetAdUnitBidders => {
  const ability = useAbility()
  const [adUnitBidders, setAdUnitBidders] = useState<AdUnitBidderSlice[]>([])
  const [count, setCount] = useState<number>(0)

  const {
    csParamsSchema,
    domain: { id: domainId },
    s2sParamsSchema,
    workspaceBidder: { id: workspaceBidderId },
  } = domainBidder

  const [query, { loading }] = useLazyQuery(GET_AD_UNIT_BIDDERS(ability), {
    onCompleted: ({ adUnitBidders: { nodes, totalCount: count } }): void => {
      if (nodes) {
        setAdUnitBidders(
          nodes.map((adUnitBidder: AdUnitBidderSliceDTO) =>
            fromDTO(adUnitBidder, csParamsSchema, s2sParamsSchema),
          ),
        )
        setCount(count)
      }
    },
  })

  useEffect(() => {
    query({
      variables: {
        domainId,
        first,
        last,
        sort: sortToDTO(sort),
        terms: filters,
        workspaceBidderId,
      },
    })
  }, [domainId, first, last, filters, sort])

  return {
    adUnitBidders,
    count,
    loading,
  }
}
